<template>
  <div class="t_novper">
    <van-sticky>
      <div
        class="top_swip"
        :style="{ background: newMarkInfo.color }"
        :class="titleList.length == 0 ? 'nim-height_x' : ''"
      >
        <div class="nav_viwper">
          <div class="flex" style="align-items: center">
            <div class="user_img" @click="showEnterprise">
              <img class="img_one" :src="storeInfo.store_logo" alt="" />
              <img
                class="img_two"
                :src="ossImgPath + '240315/dgas.png'"
                alt=""
              />
            </div>
            <div class="user_name t_line" @click="showEnterprise">
              {{ storeInfo.store_name }}
            </div>
            <div class="t_search" @click="() => goPathUrl('/search')">
              <img
                class="search_op"
                :src="ossImgPath + '240315/gsfshg.png'"
                alt=""
              />
              <div class="search_text">请输入</div>
              <!-- <input type="text" disabled placeholder="输入您需要的商品" name="" id=""> -->
            </div>
          </div>
          <div class="top_kefu kefu_rt pr" @click="goPhoneStore">
            <img :src="ossImgPath + '240315/dasfa.png'" alt="" />
            <div>客服</div>
            <a
              v-if="this.storeInfo.is_custorm_count == 1"
              class="phone_tel_x"
              :href="demoShow ? 'javascript:;' : 'tel:' + storeInfo.phone_mob"
            ></a>
          </div>

          <div class="top_kefu" @click="() => goPathUrl('/order?type=0', true)">
            <img :src="ossImgPath + '240315/fdsgs.png'" alt="" />
            <div>订单</div>
          </div>
          <div class="top_kefu" @click="() => goPathUrl('/shareList', true)">
            <img :src="ossImgPath + '250326-fx.png'" alt="" />
            <div>分享</div>
          </div>
        </div>
        <div class="tab_top" v-if="titleList.length > 0">
          <!-- 		<div :class="[cur == item.cate_id ? 'cur_tab' : '', 'tab_item']" v-for="(item, idx) in  titleList"
						:key="idx" @click="changeTab(item.cate_id)">{{
            item.cate_name }}
					</div> -->
          <van-tabs
            v-model="tabActive"
            line-width="19"
            line-height="2"
            @click="changeTab"
            :border="false"
            title-active-color="#ffffff"
            title-inactive-color="#ffffff"
            class="my_tab_style"
            background="rgba(255,255,255,0)"
          >
            <van-tab
              title-class="tab_item_xx"
              :title="item.cate_name"
              v-for="(item, idx) in titleList"
              :key="idx"
            >
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </van-sticky>

    <div v-if="creatIndex == cur">
      <van-swipe
        class="home_swipe home_swipex-x"
        style="min-height: 8rem"
        :autoplay="0"
        indicator-color="white"
      >
        <van-swipe-item v-for="(item, index) in swipeList" :key="index">
          <img :src="item.image" alt class="topbg" />
        </van-swipe-item>
      </van-swipe>
      <div class="t_vife">
        <div
          class="t_hot"
          :style="{ background: 'url(' + newMarkInfo.heat_img + ')' }"
        >
          <div class="hot_top" @click="() => goPathUrl('/Ranking?type=2')">
            <div class="t_left">
              <div class="left_name">热门兑换</div>
              <div class="left_lable">库存有限 先到先得</div>
            </div>
            <div class="t_right">
              <div
                :style="{
                  background: newMarkInfo.color,
                  color: newMarkInfo.text_color,
                }"
              >
                大家都在兑
              </div>
              <img :src="ossImgPath + '240315/right.png'" alt="" />
            </div>
          </div>
          <div class="hot_goods">
            <img
              v-for="(index, i) in imgList[imgIndex]"
              style="width: 3rem; height: 3rem"
              :class="boxitem"
              :key="i"
              :src="index.goods_image"
              alt=""
              @click="() => goPathUrl('/shopDetail?id=' + index.stock_id)"
            />
          </div>
        </div>
      </div>
      <div class="t_advertisement" v-if="ad_list.length > 0">
        <img
          v-for="(item, idx) in ad_list"
          :key="idx"
          class="ment_img"
          :src="item.image"
          @click="linkWarp(item)"
          alt="123"
        />
      </div>
      <div class="can_content">
        <div class="can_viper">
          <div class="top_line">
            <div class="can_top">
              <div class="w_wein" v-if="isLogin">
                <span>可用</span>
                <span class="we_red" :style="{ color: newMarkInfo.color }">{{
                  b_money || 0
                }}</span>
                <span>积分</span>
              </div>
              <div v-else class="login_btn" @click="goLogin()">请登录</div>
              <div
                class="can_btn"
                :style="{
                  background: newMarkInfo.color,
                  color: newMarkInfo.text_color,
                }"
                @click="() => goPathUrl('/newCollec')"
              >
                我能兑换
              </div>
            </div>
            <div class="can_top cw_ome">
              <div>已获积分，避免失效被清除！</div>
              <div class="rig_txt">省钱兑换</div>
            </div>
          </div>
          <div class="sw_content" v-if="OrderHistory.length > 0">
            <van-swipe
              vertical
              class="swipe_vertical"
              :show-indicators="false"
              :autoplay="1200"
              :touchable="false"
            >
              <van-swipe-item v-for="(item, idx) in OrderHistory" :key="idx">
                <div class="name_sw t_line">{{ item.describe }}</div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>

        <div>
          <!-- 筛选 -->

          <div class="exchange-tabs" v-show="true">
            <span
              :class="{ active: exchangeType === 0 }"
              @click="changeExchangeType(0)"
              >商城兑换</span
            >
            <span
              :class="{ active: exchangeType === 2 }"
              @click="changeExchangeType(2)"
              >门店兑换</span
            >
          </div>

          <!-- 商城兑换提示语 -->
          <div v-if="exchangeType === 0 && showMallTip" class="exchange-tip">
            <span>商城兑换，兑换完成请耐心等待快递邮寄</span>
            <span class="close-tip" @click="closeMallTip">×</span>
          </div>

          <!-- 门店兑换提示语 -->
          <div v-if="exchangeType === 2 && showStoreTip" class="exchange-tip">
            <span>门店兑换，兑换完成后请前往门店自提</span>
            <span class="close-tip" @click="closeStoreTip">×</span>
          </div>

          <div class="sort-options">
            <div
              class="sort-item"
              :class="{ active: sortKey === '' }"
              @click="changeSort('')"
            >
              综合
            </div>
            <div
              class="sort-item"
              :class="{
                active: sortKey === 'jinbi',
                asc: sortOrder === 'asc',
                desc: sortOrder === 'desc',
              }"
              @click="changeSort('jinbi')"
            >
              积分
              <span class="sort-icon"></span>
            </div>
            <div
              class="sort-item"
              :class="{
                active: sortKey === 'sales',
                asc: sortOrder === 'asc',
                desc: sortOrder === 'desc',
              }"
              @click="changeSort('sales')"
            >
              兑换量
              <span class="sort-icon"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="goods_list" v-if="isLoading">
      <div v-for="(item, idx) in shopList" :key="idx">
        <homeCard
          :itemObj="item"
          :is_show_price="is_show_retail_price"
          :newMarkInfo="newMarkInfo"
        ></homeCard>
      </div>
    </div>
    <div class="null_data_style" v-if="shopList.length == 0">
      <img :src="ossImgPath + 'null_new_x.png'" alt="" />
      <p>暂无商品</p>
    </div>

    <!-- 没有更多数据提示 (新模式) -->
    <div v-if="!isNoData && shopList.length > 0" class="no-more-data">
      <p>加载完了</p>
    </div>

    <div class="quan_pre" v-if="isPre"></div>
    <!-- 小程序部署通知20220831 状态 0 未开始部署 1部署中。2优质用户不需部署3部署完成-->
    <!-- v-if="xcxInfo.type == 0 || xcxInfo.type == 1 || xcxInfo.type == 3" -->

    <div
      class="mod"
      v-if="xcxInfo.type == 0 || xcxInfo.type == 1 || xcxInfo.type == 3"
    >
      <div class="jifenpop jifenpop_xcx">
        <h4>温馨提示</h4>
        <div class="xcx_code">
          <article>{{ xcxInfo.msg }}</article>
          <img
            class="wxcode"
            v-if="xcxInfo.type == 3"
            :src="xcxInfo.wx_code"
            alt
          />
          <p>
            <a :href="'tel:' + storeInfo.phone_mob"> 联系商家 </a>
          </p>
        </div>
      </div>
    </div>
    <!-- v-if="demoShow && !preview"  -->
    <!-- <div  @click="wantUseFg" class="choose_emplate">
			我要使用
		</div> -->
    <phoneList ref="phoneList"></phoneList>
    <!-- <phoneList @custom-event="handleEvent"></phoneList> -->
  </div>
</template>

<script>
import homeCard from "@/components/homeCard.vue";
import phoneList from "@/components/phoneList";
import { sendRequest, getOpenid } from "@/assets/public";
import urlconfig from "@/config.js";
import { Toast, Dialog } from "vant";
export default {
  components: {
    homeCard,
    phoneList,
  },
  props: {
    shopList: {
      type: Array,
    },
    storeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    isPre: {
      type: Boolean,
      default: false,
    },
    b_money: {
      type: [String, Number],
      default: 0,
    },
    is_show_retail_price: {
      type: [String, Number],
      default: 0,
    },
    newMarkInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    yl_mark_id: {
      type: [String, Number],
      default: 0,
    },
    isNoData: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tabActive: 0,
      cur: 0,
      swipeList: [],
      imgList: [],
      imgIndex: 0,
      boxitem: "",
      activeKey: 0,
      titleList: [],
      creatIndex: 0,
      OrderHistory: [],
      demoShow: false, // 模板预览
      ad_list: [],
      isLogin: localStorage.getItem("token"), //是否登录
      isLoading: false,
      xcxInfo: {},
      exchangeType: 0, // 0:商品兑换 2:门店兑换
      showMallTip: sessionStorage.getItem("showMallTip") !== "true", // 控制商城兑换提示语显示
      showStoreTip: sessionStorage.getItem("showStoreTip") !== "true", // 控制门店兑换提示语显示
      sortKey: "", // '':综合, 'jinbi':积分, 'sales':兑换量
      sortOrder: "asc", // 'asc':升序, 'desc':降序
    };
  },
  created() {
    // this.getBottomList()
  },
  mounted() {
    this.initShop();
    this.getClassFly();
    this.getOrderHistory();

    setTimeout(() => {
      this.getBannerListNewFg();
    }, 500);

    this.handleEvent();
    this.getCheckPresell();
    // 初始化时触发排序改变事件，带上默认排序和当前兑换类型
    this.$emit("sortChange", {
      goods_type: this.exchangeType,
      order: this.sortKey,
      order_type: this.sortOrder,
    });
  },
  methods: {
    //小程序部署
    getCheckPresell() {
      sendRequest("user/checkPresell").then((res) => {
        if (res.status == 200) {
          this.xcxInfo = res.content.store;
          return;
        }
      });
    },
    goPhoneStore() {
      console.log(this.storeInfo, this.storeInfo.is_custorm_count);

      let is_custorm_count = this.storeInfo.is_custorm_count;
      if (is_custorm_count == 1) {
        //1个电话
        console.log("直接拨打");
      } else if (is_custorm_count > 1) {
        console.log("出弹框选择");
        this.$refs.phoneList.showPopFg();
      } else {
        // 0  商家没设置
        Toast(this.storeInfo.is_custorm_msg);
      }
      //联系商家
      return;
    },
    handleEvent(data) {
      console.log("接收到数据:", data); // 输出：接收到数据: 这是传递给父组件的数据
      this.kfMemberNum = data;
    },
    linkWarp(item) {
      window.location.href = item.link_url;
    },
    async getBannerListNewFg() {
      console.log("=====9999");
      let res = await sendRequest("user/getBannerListNew", {
        store_id: localStorage.getItem("store_id"),
        mark_id: this.yl_mark_id, //预览模板id
      });
      console.log(res);
      this.swipeList = res.content.banner_list;
      this.ad_list = res.content.ad_list;

      setTimeout(() => {
        this.isLoading = true;
      }, 100);

      console.log(this.yl_mark_id, "======yyy===www");
    },
    getOrderHistory() {
      let data = {
        goods_type: 1,
      };
      sendRequest("goods/orderHistory", data).then((result) => {
        if (result.status == 200) {
          this.OrderHistory = result.content;
        }
      });
    },
    goPathUrl(url, flag) {
      console.log(url);
      this.$emit("goPathUrl", url, flag);
    },
    showEnterprise() {
      this.$emit("showEnterprise");
    },
    pathSwiper(item) {
      this.$emit("pathSwiper", item);
    },
    changeTab(index) {
      // console.log(index,'---',this.titleList[index])
      // return
      let id = this.titleList[index]["cate_id"];
      this.cur = id;
      this.shopList = [];
      // this.getBottomList()
      this.$emit("refresh", id);
    },

    // 获取分类
    async getClassFly() {
      // 全部分类
      let { content } = await sendRequest("goods/category", {
        tag: 1,
      });
      this.titleList = content;
      this.cur = content[0].cate_id;
      this.creatIndex = content[0].cate_id;
      for (let item in content) {
        if (content[item].cate_id == this.cate_id) {
          this.activeKey = item;
        }
      }
    },
    // 获取榜单商品
    initShop() {
      sendRequest("goods/rank_index", {
        page: 1,
        tag_type: 1,
        goods_type: 0,
        limit: 20,
      })
        .then((result) => {
          if (result.status == 200) {
            this.imgList = this.chunkArray(result.content.list, 4);
            console.log(this.imgList);
            setTimeout(() => {
              this.play();
            }, 3000);
          }
        })
        .catch((err) => {});
    },
    // 等待 + 缩小
    play() {
      this.boxitem = "box";
      setTimeout(() => {
        this.imgIndex = this.imgIndex + 1;
        if (this.imgIndex > this.imgList.length - 1) {
          this.imgIndex = 0;
        }
        this.boxFn();
      }, 500);
    },
    // 放大
    boxFn() {
      this.boxitem = "scaleImg";
      setTimeout(() => {
        this.play();
      }, 5000);
    },
    chunkArray(array, chunkSize) {
      let result = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
      }
      return result;
    },
    goLogin() {
      if (this.isWexinLogin) {
        var appid = "wxcef271c70c3c8428"; // appid
        var url = window.encodeURIComponent(
          `${urlconfig.goPath}personalCenter`
        ); // 回调链接地址，需转码为URI格式，必须去除#后的参数
        var scope = "snsapi_base"; // snsapi_base静默授权，snsapi_userinfo弹出授权页面
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=state#wechat_redirect`;
      } else {
        this.$router.push("/login");
      }
    },
    changeExchangeType(type) {
      this.exchangeType = type;
      // 切换tab时，提示语显示状态取决于各自的sessionStorage状态
      // this.showTip = sessionStorage.getItem('showTip') !== 'false';
      // 触发排序改变事件
      this.$emit("sortChange", {
        goods_type: this.exchangeType,
        order: this.sortKey,
        order_type: this.sortOrder,
        isfasle: true,
      });
    },
    closeMallTip() {
      this.showMallTip = false;
      sessionStorage.setItem("showMallTip", "false");
    },
    closeStoreTip() {
      this.showStoreTip = false;
      sessionStorage.setItem("showStoreTip", "false");
    },
    changeSort(key) {
      if (this.sortKey === key) {
        // 如果点击当前排序字段，切换排序方向
        // 注意：综合排序没有升降序，点击综合始终重置为默认
        if (key !== "") {
          this.sortOrder = this.sortOrder == "asc" ? "desc" : "asc";
        } else {
          this.sortOrder = "asc";
        }
      } else {
        // 如果点击不同字段，设置新字段，默认升序
        this.sortKey = key;
        this.sortOrder = "asc";
      }
      // 触发排序改变事件
      this.$emit("sortChange", {
        goods_type: this.exchangeType,
        order: this.sortKey,
        order_type: this.sortOrder,
      });
    },
  },
};
</script>

<style scoped>
.null_data_style {
  text-align: center;
  color: #969799;
  font-size: 0.56rem;
  padding-bottom: 3rem;
}

.null_data_style img {
  width: 30%;
}
.choose_emplate {
  width: 13.6rem;
  height: 1.36rem;
  line-height: 1.36rem;
  text-align: center;
  color: #fff;
  background: #fd7128;
  border-radius: 34rpx;
  border-radius: 25px;
  margin: 0 auto;
  position: fixed;
  bottom: 1rem;
  left: 0.7rem;
  z-index: 11111;
}
.quan_pre {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  opacity: 0;
  top: 0;
  left: 0;
  z-index: 10000;
}
/* .t_novper {
  min-height: 100vh;
  background: #F3F3F3;
} */

.swipe_vertical {
  width: 11.8rem;
  padding: 0 0.6rem;
  height: 0.9rem;
  line-height: 0.9rem;
}

.top_swip {
  width: 15rem;
  height: 3.52rem;
  background: linear-gradient(180deg, #f1001d 0%, #ff2431 100%);
}

.top_swip.nim-height_x {
  height: 2rem;
}

.user_img {
  position: relative;
  width: 1.12rem;
  height: 1.12rem;
  margin-left: 0.48rem;
}

.nav_viwper {
  display: flex;
  align-items: center;
  padding-top: 0.58rem;
  justify-content: space-around;
  padding-right: 0.2rem;
}

.user_img .img_one {
  width: 1.12rem;
  height: 1.12rem;
  border-radius: 50%;
  background: #ffffff;
}

.user_img .img_two {
  position: absolute;
  display: block;
  width: 0.48rem;
  height: 0.48rem;
  bottom: 0;
  right: -0.08rem;
}

.login_btn {
  color: #333;
  font-size: 0.5rem;
}

.user_name {
  max-width: 3rem;
  height: 0.8rem;
  overflow: hidden;
  font-weight: 500;
  font-size: 0.56rem;
  color: #ffffff;
  line-height: 0.8rem;
  text-align: left;
  font-style: normal;
  margin-left: 0.2rem;
  margin-right: 0.2rem;
}

.search_op {
  display: block;
  width: 0.54rem;
  height: 0.6rem;
}

.t_search {
  flex-shrink: 0;
  height: 0.6rem;
  display: flex;
  align-items: center;
  background: #ffffff;
  width: 4rem;
  background: #feffff;
  border-radius: 0.64rem;
  padding: 0.26rem 0 0.26rem 0.4rem;
  margin-right: 0.4rem;
}

.t_search .search_text {
  border: none;
  width: 4.2rem;
  font-size: 0.46rem;
  margin-left: 0.2rem;
  color: #c8c9cc;
}

.top_kefu img {
  display: block;
  width: 0.8rem;
  height: 0.82rem;
  margin: 0 auto;
}

.top_kefu div {
  font-size: 0.4rem;
  color: #fff;
  line-height: 0.4rem;
  text-align: justify;
  font-style: normal;
  text-align: center;
  margin-top: 0.06rem;
}
/* 
	.kefu_rt {
		margin-right: .54rem;
	} */

.my_tab_style {
  height: 1.2rem;
}

.tab_top {
  /* display: inline-flex;
		align-items: center; */
  height: 1.2rem;
  padding-left: 0.18rem;
  width: 14.52rem;
  /* 	overflow-x: scroll;
		overflow-y: hidden;
		scrollbar-width: none;
		-webkit-overflow-scrolling: touch; */
  margin-top: 0.4rem;
}

.tab_top .tab_item_xx {
  height: 1.2rem;
}

.tab_item {
  font-size: 0.56rem;
  color: #ffffff;
  text-align: left;
  font-style: normal;
  white-space: nowrap;
  margin-right: 0.64rem;
}

.cur_tab {
  position: relative;
  font-weight: 500;
  font-size: 0.64rem;
  color: #ffffff;
}

.cur_tab::after {
  position: absolute;
  content: "";
  width: 0.76rem;
  height: 0.08rem;
  background: #ffffff;
  border-radius: 0.06rem;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: -0.16rem;
}

.t_vife {
  width: 14.2rem;
  margin: 1rem auto 0.4rem 0.4rem;
  border-radius: 0.4rem 0.4rem 0px 0px;
  transform: translate(0, -0.74rem);
  background: #f3f3f3;

  /* padding: .6rem .4rem 0; */
}

.t_hot {
  padding: 0.36rem 0.4rem 0.4rem;
  background: linear-gradient(120deg, #f9ece0 0%, #ffffff 100%);
  border-radius: 0.4rem;
}

.hot_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.t_left {
  display: flex;
  align-items: center;
}

.left_name {
  font-weight: 600;
  font-size: 0.56rem;
  color: #000000;
  text-align: center;
  font-style: normal;
}

.left_lable {
  font-size: 0.44rem;
  color: #999999;
  text-align: center;
  font-style: normal;
  margin-left: 0.2rem;
}

.t_right {
  display: flex;
  align-items: center;
}

.t_right div {
  font-size: 0.4rem;
  color: #ffffff;
  text-align: center;
  font-style: normal;
  padding: 0 0.3rem;
  height: 0.72rem;
  line-height: 0.76rem;
  overflow: hidden;
  background: #ff463a;
  border-radius: 0.36rem;
}

.t_right img {
  width: 0.64rem;
  height: 0.64rem;
}

.hot_goods {
  display: flex;
  align-items: center;
  margin-top: 0.36rem;
}

.hot_goods img {
  border-radius: 0.2rem;
}

.goods_img {
  width: 3rem;
  height: 3rem;
}

.t_advertisement {
  padding: 0 0.48rem 0 0.54rem;
  margin-bottom: 0.4rem;
  margin-top: -0.8rem;
}

.ment_img {
  display: block;
  width: 100%;
  height: 4.32rem;
}

.can_content {
  padding: 0 0.4rem;
}

.can_viper {
  background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
  border-radius: 0.4rem;
  padding: 0.4rem 0.52rem 0.34rem 0.68rem;
}

.top_line {
  border-bottom: 1px solid #f3f3f3;
}

.w_wein {
  font-weight: 500;
  font-size: 0.44rem;
  color: #999999;
  text-align: left;
  font-style: normal;
}

.w_wein .we_red {
  font-weight: 600;
  font-size: 0.72rem;
  color: #ff463a;
  text-align: left;
  font-style: normal;
  padding: 0 0.2rem;
}

.can_btn {
  font-size: 0.56rem;
  color: #ffffff;
  text-align: center;
  font-style: normal;
  padding: 0 0.54rem;
  height: 1.2rem;
  line-height: 1.2rem;
  background: #ff463a;
  border-radius: 0.32rem;
}

.can_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cw_ome {
  font-size: 0.4rem;
  color: #a1a6ac;
  text-align: center;
  font-style: normal;
  margin-top: 0.2rem;
  margin-bottom: 0.3rem;
}

.rig_txt {
  margin-right: 0.82rem;
}

.sw_content {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 23px;
  /* padding: .26rem .6rem; */
  margin-top: 0.34rem;
}

.name_sw {
  width: 11.8rem;
  font-size: 0.4rem;
  color: #ffffff;
  text-align: center;
}

.goods_list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 0.4rem;
  margin-top: 0.4rem;
}

.hot_goods img:nth-child(1) {
  margin-right: 0.48rem;
}

.hot_goods img:nth-child(2) {
  margin-right: 0.48rem;
}

.hot_goods img:nth-child(3) {
  margin-right: 0.48rem;
}

.box {
  animation-name: scaleAnimation;
  /* 引入自定义动画 */
  animation-duration: 0.5s;
  /* 动画持续时间 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线 */
  /* 交替反向运动 */
  animation-fill-mode: forwards;
  /* 保持最后一帧状态 */
  /* 开始前延迟1秒 */
  transform-origin: center;
  animation-iteration-count: 1;
  /* 缩放原点位于元素中心 */
}

@keyframes scaleAnimation {
  0% {
    transform: scale(1);
    /* 初始状态，没有缩放 */
  }

  100% {
    transform: scale(0);
    /* 返回初始状态 */
  }
}

.scaleImg {
  width: 3rem;
  height: 3rem;
  border-radius: 0.2rem;
  animation-name: openScaleImg;
  /* 引入自定义动画 */
  animation-duration: 0.5s;
  /* 动画持续时间 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线 */
  animation-direction: alternate;
  /* 交替反向运动 */
  animation-fill-mode: forwards;
  /* 保持最后一帧状态 */
  /* 开始前延迟1秒 */
  transform-origin: center;
  animation-iteration-count: 1;
  /* 缩放原点位于元素中心 */
}

@keyframes openScaleImg {
  0% {
    transform: scale(0);
    /* 初始状态，没有缩放 */
  }

  100% {
    transform: scale(1);
    /* 返回初始状态 */
  }
}

.exchange-tabs {
  display: flex;
  margin: 0.5rem 0 0.2rem 0;
}
.exchange-tabs span {
  flex: 1;
  text-align: center;
  padding: 0.3rem 0;
  font-size: 0.6rem;
  color: #999;
  background: transparent;
  font-weight: 400;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: color 0.2s;
}
.exchange-tabs span.active {
  color: #fd3e3e;
  font-weight: bold;
  background: transparent;
  border: none;
  border-radius: 0;
}
.exchange-tip {
  background: #fff1f1;
  color: #fd3e3e;
  font-size: 0.48rem;
  border-radius: 1.5625rem;
  padding: 0.2rem 0.4rem;
  margin-bottom: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 8;
}
.close-tip {
  cursor: pointer;
  margin-left: 0.4rem;
  font-size: 0.6rem;
}

.sort-options {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.4rem 0;
  /* background-color: #fff; */
  margin-bottom: 0.4rem;
  font-size: 0.56rem;
  color: #999;
}

.sort-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.sort-item.active {
  color: #fd3e3e;
}

.sort-icon {
  display: inline-block;
  width: 0.4rem;
  height: 0.5rem;
  margin-left: 0.1rem;
  position: relative;
}

.sort-icon::before,
.sort-icon::after {
  content: "";
  position: absolute;
  left: 0;
  width: 0;
  height: 0;
  border-left: 0.2rem solid transparent;
  border-right: 0.2rem solid transparent;
}

.sort-icon::before {
  top: 0;
  border-bottom: 0.2rem solid #999;
}

.sort-icon::after {
  bottom: 0;
  border-top: 0.2rem solid #999;
}

.sort-item.active .sort-icon::before {
  border-bottom-color: #fd3e3e;
}

.sort-item.active .sort-icon::after {
  border-top-color: #fd3e3e;
}

.sort-item.active.asc .sort-icon::before {
  border-bottom-color: #fd3e3e;
}

.sort-item.active.asc .sort-icon::after {
  border-top-color: #999;
}

.sort-item.active.desc .sort-icon::before {
  border-bottom-color: #999;
}

.sort-item.active.desc .sort-icon::after {
  border-top-color: #fd3e3e;
}

.no-more-data {
  text-align: center;
  padding: 0.5rem 0;
  color: #999;
  font-size: 0.56rem;
}
</style>
<style>
.my_tab_style .van-tabs__wrap .van-tab__text {
  font-size: 0.56rem;
}

.my_tab_style .van-tabs__wrap .van-tab--active .van-tab__text {
  font-size: 0.64rem;
}

.my_tab_style .van-tabs__wrap .van-tabs__wrap--scrollable {
  height: 1.2rem !important;
  line-height: 1.2rem !important;
}

.tab_top .van-tabs--line .van-tabs__wrap {
  height: 1.2rem !important;
  line-height: 1.2rem !important;
}

.my_tab_style .van-tab {
  height: 1.2rem !important;
  line-height: 1.2rem !important;
}

.my_tab_style .van-tabs--line.van-tabs__wrap {
  height: 1.2rem;
  line-height: 1.2rem;
}

.my_tab_style.van-tabs .van-tab {
  padding: 0 0.32rem;
  flex-basis: inherit !important;
  max-width: 3.3rem;
}

.my_tab_style .van-tabs__line {
  background: #ffffff;
  bottom: 0.01rem;
  /* width:0.76rem;
		left: 50%;
		transform: translateX(-50%); */
}

.my_tab_style .van-tabs__nav {
  padding-bottom: 0;
}

.home_swipe img {
  width: 100%;
  height: auto;
}

.home_swipex-x .van-swipe__indicators {
  bottom: 2.9rem;
}

.home_swipex-x .van-swipe__indicators .van-swipe__indicator {
  width: 0.28rem;
  height: 0.28rem;
}

.home_swipex-x .van-swipe__indicator.van-swipe__indicator--active {
  width: 0.52rem;
  height: 0.28rem;
  background: #ffffff;
  border-radius: 0.14rem;
}

/* 隐藏 Chrome、Safari 和 Opera 的滚动条 */
::-webkit-scrollbar {
  display: none;
}
.pr {
  position: relative;
}
.phone_tel_x {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  background: transparent;
}

.jifenpop {
  width: 12.44rem;
  height: 9.68rem;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.2rem;
}

.jifenpop h4 {
  color: #333333;
  font-size: 0.68rem;
  text-align: center;
}

.jifenpop ul {
  padding: 0 0.68rem;
}

.jifenpop li {
  line-height: 1rem;
  color: #666666;
  font-size: 0.56rem;
}

.jifenpop button {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 12.44rem;
  height: 2.08rem;
  border-top: 0.0625rem solid #ddd;
  text-align: center;
  color: #fd3e3e;
  font-size: 0.68rem;
}
</style>